var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ShopNewDemandService from '../../api/ShopNewDemandService';
import ObjectHelper from '../../helper/objectHelper';
import Header from "./components/Header.vue";
import CheckDialog from './components/CheckDialog';
import { Loading } from 'element-ui';
import viewImgList from '../shopAfterSales/components/viewImgList';
var shopNewDemandList = (function (_super) {
    __extends(shopNewDemandList, _super);
    function shopNewDemandList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 300;
        return _this;
    }
    shopNewDemandList.prototype.created = function () {
        this.service = ShopNewDemandService.getInstance();
    };
    shopNewDemandList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 210;
        }, 300);
    };
    shopNewDemandList.prototype.search = function (filter) {
        var pagination = this.$refs.pagination;
        var currentPager = pagination ? pagination.getPage() : { page: 1, start: 0, limit: 20 };
        if (pagination) {
            pagination.handleCurrentChange(1);
            return;
        }
        if (filter) {
            this.filter = filter;
        }
        this.getList(currentPager);
    };
    shopNewDemandList.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(__assign({}, pager, this.filter))
            .then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data || [];
            _this.total = res.data.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    shopNewDemandList.prototype.handle = function (row) {
        var _this = this;
        var instance = this.$dialog(CheckDialog, {
            data: {
                rowData: ObjectHelper.serialize(row)
            }
        }, {
            title: "处理新需求",
            width: 526,
            height: 340
        }).instance;
        instance.$on("check:ok", function () {
            _this.getList();
        });
    };
    shopNewDemandList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    shopNewDemandList = __decorate([
        Component({
            components: {
                'list-header': Header,
                viewImgList: viewImgList
            }
        })
    ], shopNewDemandList);
    return shopNewDemandList;
}(Vue));
export default shopNewDemandList;
